import React, { useEffect, useState } from "react";
import { Table, Switch, notification, Button, Input } from "antd";
import { closeModal } from "utils";
import { useDispatch } from "react-redux";
import { setModal } from "features/modalSlice";
import {
  getServicePackages,
  updateServicePackages,
} from "features/servicePackageSlice";
import { PayloadType } from "type";
import queryString from "query-string";
import { useSelector } from "react-redux";

const SPACKAGE_FUNC = {
  THONG_KE_TONG_QUAN_DAN: "thong_ke_tong_quan_dan",
  THONG_KE_THEO_KHU_VUC_CHUONG_NAI: "thong_ke_theo_khu_vuc_chuong_nai",
  THONG_KE_THEO_CHUONG_THIT: "thong_ke_theo_chuong_thit",
  THEM_SU_KIEN: "them_su_kien",

  TRA_CUU: "tra_cuu",
  NHAP_DAN: "nhap_dan",
  DS_THIT: "ds_thit",
  DS_NAI: "ds_nai",
  HAU_BI: "hau_bi",
  DS_CON: "ds_con",
  DS_DUC: "ds_duc",
  NAI_BENH: "nai_benh",
  DUC_BENH: "duc_benh",
  CON_BENH: "con_benh",
  THIT_BENH: "thit_benh",
  THUOC: "thuoc",
  THUC_AN: "thuc_an",
  VACXIN: "vacin",
  CAI_SUA: "cai_sua",
  XUAT_BAN: "xuat_ban",
  TIEP_NHAN: "tiep_nhan",

  QUAN_LY_CHI_PHI: "quan_ly_chi_phi",
  BC_HANG_NGAY_HEO_THIT: "bc_hang_ngay_heo_thit",
  BC_HANG_NGAY_CHUONG_NAI: "bc_hang_ngay_chuong_nai",
  THEO_DOI_17_TUAN_TRAI: "theo_doi_17_tuan_trai",
  THEO_DOI_PHOI_GIONG: "theo_doi_phoi_giong",
  BC_TONG_HOP: "bc_tong_hop",
  BC_TANG_TRUONG: "bc_tang_truong",
  THONG_KE_THUOC_THUC_AN_THEO_CHUONG: "thong_ke_thuoc_thuc_an_theo_chuong",
  QUAN_LY_TRAI_CON: "quan_ly_trai_con",
  THIET_LAP_TEN_THUOC: "thiet_lap_ten_thuoc",
  THIET_LAP_TEN_THUC_AN: "thiet_lap_ten_thuc_an",
  THIET_LAP_DINH_MUC_THUC_AN: "thiet_lap_dinh_muc_thuc_an",
  THIET_LAP_QUY_TRINH: "thiet_lap_quy_trinh",
  THIET_LAP_KE_HOACH: "thiet_lap_ke_hoach",
  QUAN_LY_PHAN_QUYEN: "quan_ly_phan_quyen",
  QUAN_LY_TAI_KHOAN_KY_THUAT_VIEN: "quan_ly_tai_khoan_ky_thuat_vien",
  QUAN_LY_THONG_BAO: "quan_ly_thong_bao",
  THIET_LAP_THONG_SO: "thiet_lap_thong_so",
  THIET_LAP_THONG_SO_TLTB: "thiet_lap_thong_so_tltb",
  QUAN_LY_KHACH_HANG: "quan_ly_khach_hang",
  WEB: "web",
  THIET_LAP_GIONG_NGUON_GOC: "thiet_lap_giong_nguon_goc",
};

// Mapping tên tiếng Việt cho các chức năng
const VIETNAMESE_NAMES = {
  THONG_KE_TONG_QUAN_DAN: "Thống kê tổng quan đàn",
  THONG_KE_THEO_KHU_VUC_CHUONG_NAI: "Thống kê theo khu vực chuồng nái",
  THONG_KE_THEO_CHUONG_THIT: "Thống kê theo chuồng thịt",
  THEM_SU_KIEN: "Thêm sự kiện",

  TRA_CUU: "Tra cứu",
  NHAP_DAN: "Nhập đàn",
  DS_THIT: "Danh sách thịt",
  DS_NAI: "Danh sách nái",
  HAU_BI: "Hậu bị",
  DS_CON: "Danh sách con",
  DS_DUC: "Danh sách đực",
  NAI_BENH: "Nái bệnh",
  DUC_BENH: "Đực bệnh",
  CON_BENH: "Con bệnh",
  THIT_BENH: "Thịt bệnh",
  THUOC: "Thuốc",
  THUC_AN: "Thức ăn",
  VACXIN: "Vacxin",
  CAI_SUA: "Cai sữa",
  XUAT_BAN: "Xuất bán",
  TIEP_NHAN: "Tiếp nhận",

  QUAN_LY_CHI_PHI: "Quản lý chi phí",
  BC_HANG_NGAY_HEO_THIT: "Báo cáo hàng ngày heo thịt",
  BC_HANG_NGAY_CHUONG_NAI: "Báo cáo hàng ngày chuồng nái",
  THEO_DOI_17_TUAN_TRAI: "Theo dõi 17 tuần trại",
  THEO_DOI_PHOI_GIONG: "Theo dõi phối giống",
  BC_TONG_HOP: "Báo cáo tổng hợp",
  BC_TANG_TRUONG: "Báo cáo tăng trưởng",
  THONG_KE_THUOC_THUC_AN_THEO_CHUONG: "Thống kê thuốc thức ăn theo chuồng",
  QUAN_LY_TRAI_CON: "Quản lý trại con",
  THIET_LAP_TEN_THUOC: "Thiết lập tên thuốc",
  THIET_LAP_TEN_THUC_AN: "Thiết lập tên thức ăn",
  THIET_LAP_DINH_MUC_THUC_AN: "Thiết lập định mức thức ăn",
  THIET_LAP_QUY_TRINH: "Thiết lập quy trình",
  THIET_LAP_KE_HOACH: "Thiết lập kế hoạch",
  QUAN_LY_PHAN_QUYEN: "Quản lý phân quyền",
  QUAN_LY_TAI_KHOAN_KY_THUAT_VIEN: "Quản lý tài khoản kỹ thuật viên",
  QUAN_LY_THONG_BAO: "Quản lý thông báo",
  THIET_LAP_THONG_SO: "Thiết lập thông số",
  THIET_LAP_THONG_SO_TLTB: "Thiết lập thông số TLTB",
  QUAN_LY_KHACH_HANG: "Quản lý khách hàng",
  WEB: "Web",
  THIET_LAP_GIONG_NGUON_GOC: "Thiết lập giống & nguồn gốc",
};

// Component modal chỉnh sửa quyền
interface PermissionModalProps {
  record: any; // Replace 'any' with a more specific type if available
}

const PermissionModal: React.FC<PermissionModalProps> = ({ record }) => {
  const [permissions, setPermissions] = useState<{ [key: string]: boolean }>(
    () => {
      // Khởi tạo state permissions từ record.funcs (mảng string) hoặc default
      const initialPermissions: { [key: string]: boolean } = {};
      const recordFuncs = record?.funcs || []; // Mảng string từ record

      Object.entries(SPACKAGE_FUNC).forEach(([key, value]) => {
        // Kiểm tra xem function code có trong mảng funcs không
        initialPermissions[value] = recordFuncs.includes(value);
      });
      return initialPermissions;
    }
  );

  useEffect(() => {
    const initialPermissions: { [key: string]: boolean } = {};
    const recordFuncs = record?.funcs || [];
    Object.entries(SPACKAGE_FUNC).forEach(([key, value]) => {
      initialPermissions[value] = recordFuncs.includes(value);
    });
    setPermissions(initialPermissions);
  }, [record]);
  const dispatch = useDispatch();
  const { query } = useSelector((state: any) => state.servicePackageReducer);

  const handlePermissionChange = (code: any, checked: any) => {
    setPermissions((prev) => ({
      ...prev,
      [code]: checked,
    }));
  };

  function handleGetServicePacks() {
    const payload: PayloadType = {
      query: queryString.stringify(
        {
          ...query,
          sortBy: "createdAt:desc",
        },
        {
          skipNull: true,
          skipEmptyString: true,
        }
      ),
      skipUpdateReducer: false,
      callback: {
        success() {},
        failed(errorMessage) {
          notification.error({
            message: "Có lỗi xảy ra trong quá trình lấy danh sách!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(getServicePackages(payload));
  }

  const handleSave = () => {
    // Chuyển đổi từ object boolean sang mảng string
    const selectedFuncs = Object.entries(permissions)
      .filter(([code, enabled]) => enabled)
      .map(([code, enabled]) => code);

    // Logic lưu quyền - thay thế bằng API call thực tế
    const payload = {
      params: record?.id,
      body: {
        ...record,
        id: undefined,
        creator: undefined,
        updator: undefined,
        farmScaleTTNId: record?.farmScaleTTNId?.id,
        farmScaleTTTId: record?.farmScaleTTTId?.id,
        funcs: selectedFuncs,
      },
      callback: {
        success: () => {
          notification.success({
            message: "Cập nhật quyền thành công!",
          });
          handleGetServicePacks();
          closeModal(dispatch, setModal);
          // Refresh data if needed
        },
        failed: (errorMessage: any) => {
          notification.error({
            message: "Cập nhật quyền thất bại!",
            description: errorMessage,
          });
        },
      },
    };

    dispatch(updateServicePackages(payload));
  };

  const handleSelectAll = () => {
    const allSelected: { [key: string]: boolean } = {};
    Object.values(SPACKAGE_FUNC).forEach((code) => {
      allSelected[code] = true;
    });
    setPermissions(allSelected);
  };

  const handleDeselectAll = () => {
    const allDeselected: { [key: string]: boolean } = {};
    Object.values(SPACKAGE_FUNC).forEach((code) => {
      allDeselected[code] = false;
    });
    setPermissions(allDeselected);
  };

  // Chuyển đổi SPACKAGE_FUNC thành data cho table với tên tiếng Việt
  const permissionData = Object.entries(SPACKAGE_FUNC).map(
    ([name, code], index) => ({
      key: index,
      name: VIETNAMESE_NAMES[name as keyof typeof VIETNAMESE_NAMES] || name,
      code: code,
      enabled: permissions[code] || false,
    })
  );

  interface PermissionItem {
    key: number;
    name: string;
    code: string;
    enabled: boolean;
  }

  interface ColumnType {
    title: React.ReactNode;
    dataIndex?: string;
    key: string;
    width: string;
    render?: (_: any, item: PermissionItem, index: number) => React.ReactNode;
  }
  const allChecked =
    Object.values(permissions).length > 0 &&
    Object.values(permissions).every(Boolean);

  const columns: ColumnType[] = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      width: "15%",
      render: (_: any, _item: PermissionItem, index: number) => index + 1,
    },
    {
      title: "Tên",
      dataIndex: "name",
      key: "name",
      width: "60%",
    },

    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Trạng thái</span>
          <Switch
            checked={allChecked}
            onChange={(checked) => {
              if (checked) {
                handleSelectAll();
              } else {
                handleDeselectAll();
              }
            }}
          />
        </div>
      ),
      key: "enabled",
      width: "25%",
      render: (_: any, item: PermissionItem) => (
        <Switch
          checked={item.enabled}
          onChange={(checked) => handlePermissionChange(item.code, checked)}
        />
      ),
    },
  ];

  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(permissionData);

  useEffect(() => {
    const allData = Object.entries(SPACKAGE_FUNC).map(
      ([name, code], index) => ({
        key: index,
        name: VIETNAMESE_NAMES[name as keyof typeof VIETNAMESE_NAMES] || name,
        code: code,
        enabled: permissions[code] || false,
      })
    );

    const filtered = allData.filter((item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
    );

    setFilteredData(filtered);
  }, [permissions, searchText]);

  return (
    <>
      <div className="ant-modal-body">
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            gap: 8,
            justifyContent: "space-between",
          }}
        >
          <Input.Search
            placeholder="Tìm kiếm theo tên chức năng"
            allowClear
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 300, marginBottom: 12 }}
          />
        </div>
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={false}
          scroll={{ y: 400 }}
          size="middle"
        />
      </div>
      <div className="ant-modal-footer">
        <Button
          type="default"
          onClick={() => {
            closeModal(dispatch, setModal);
          }}
        >
          Huỷ
        </Button>
        <Button
          onClick={() => {
            handleSave();
          }}
          type="primary"
        >
          Lưu lại
        </Button>
      </div>
    </>
  );
};

export default PermissionModal;
